export default __webpack_public_path__ + "static/char-s-34-en-3593e5435e38a98c8dbdc352b02a190c.png";